/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 25th 2022, 4:53:37 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import * as React from "react";
import { AlertSnackBar, AlertSnackBarProps, useToggleState } from "ui-widgets";

interface FormSubmitSuccessSnackbarProps {
  isSuccessfulAPIDataSend: boolean;
  successMessage: string;
  alertProps?: Partial<AlertSnackBarProps>;
}

export const FormSubmitSuccessSnackbar = ({
  isSuccessfulAPIDataSend,
  successMessage,
  alertProps,
}: FormSubmitSuccessSnackbarProps) => {
  const {
    handleClose: handleCloseSuccessSnackBar,
    handleOpen: handleOpenSuccessSnackBar,
    open: showSuccessSnackBar,
  } = useToggleState();

  React.useEffect(() => {
    isSuccessfulAPIDataSend && handleOpenSuccessSnackBar();
  }, [isSuccessfulAPIDataSend, handleOpenSuccessSnackBar]);

  return (
    <AlertSnackBar
      open={showSuccessSnackBar}
      message={successMessage}
      severity="success"
      vertical={alertProps?.vertical ? alertProps?.vertical : "top"}
      horizontal={alertProps?.horizontal ? alertProps?.horizontal : "center"}
      handleClose={handleCloseSuccessSnackBar}
      autoClose
    />
  );
};
